import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { ReservePropertiesTypes } from "./reserve-nearby.types";
export const useNearBy = properties => {
  const $ = _c(17);
  const {
    nearbyLocations,
    roadAccessType,
    roadAccessDescription
  } = properties;
  let t0;
  if ($[0] !== nearbyLocations) {
    t0 = nearbyLocations?.slice(0, 6);
    $[0] = nearbyLocations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const firstData = t0;
  let t1;
  if ($[2] !== nearbyLocations) {
    t1 = nearbyLocations?.slice(6);
    $[2] = nearbyLocations;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const remainingData = t1;
  const [showMore, setShowMore] = useState(false);
  let t2;
  let t3;
  if ($[4] !== nearbyLocations) {
    t2 = () => {
      setShowMore(!(Array.isArray(nearbyLocations) && nearbyLocations?.length > 6));
    };
    t3 = [nearbyLocations];
    $[4] = nearbyLocations;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      LT_5_MINUTES: "\u06A9\u0645\u062A\u0631 \u0627\u0632 5 \u062F\u0642\u06CC\u0642\u0647",
      LT_10_MINUTES: "\u06A9\u0645\u062A\u0631 \u0627\u0632 10 \u062F\u0642\u06CC\u0642\u0647",
      LT_15_MINUTES: "\u06A9\u0645\u062A\u0631 \u0627\u0632 15 \u062F\u0642\u06CC\u0642\u0647",
      LT_20_MINUTES: "\u06A9\u0645\u062A\u0631 \u0627\u0632 20 \u062F\u0642\u06CC\u0642\u0647",
      LT_30_MINUTES: "\u06A9\u0645\u062A\u0631 \u0627\u0632 30 \u062F\u0642\u06CC\u0642\u0647",
      GT_30_MINUTES: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 30 \u062F\u0642\u06CC\u0642\u0647"
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const distances = t4;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      SUPERMARKET: "\u0633\u0648\u067E\u0631\u0645\u0627\u0631\u06A9\u062A",
      BAKERY: "\u0646\u0627\u0646\u0648\u0627\u06CC\u06CC",
      AIRPORT: "\u0641\u0631\u0648\u062F\u06AF\u0627\u0647",
      BUS_STATION: "\u067E\u0627\u06CC\u0627\u0646\u0647 \u0627\u062A\u0648\u0628\u0648\u0633\u200C\u0631\u0627\u0646\u06CC",
      TRAIN_STATION: "\u0627\u06CC\u0633\u062A\u06AF\u0627\u0647 \u0631\u0627\u0647\u200C\u0622\u0647\u0646",
      SUBWAY_STATION: "\u0627\u06CC\u0633\u062A\u06AF\u0627\u0647 \u0645\u062A\u0631\u0648",
      RESTAURANT: "\u0631\u0633\u062A\u0648\u0631\u0627\u0646",
      MALL: "\u0645\u0631\u06A9\u0632 \u062E\u0631\u06CC\u062F",
      GAS_STATION: "\u067E\u0645\u067E \u0628\u0646\u0632\u06CC\u0646",
      SEA: "\u062F\u0631\u06CC\u0627",
      JUNGLE: "\u062C\u0646\u06AF\u0644",
      HOLY_SHRINE: "\u062D\u0631\u0645",
      SHOPPING_MALL: "\u0645\u0631\u0627\u06A9\u0632 \u062E\u0631\u06CC\u062F",
      BEACH: "\u062F\u0631\u06CC\u0627",
      HOSPITAL: "\u0628\u06CC\u0645\u0627\u0631\u0633\u062A\u0627\u0646",
      PHARMACY: "\u062F\u0627\u0631\u0648\u062E\u0627\u0646\u0647",
      BANK: "\u0628\u0627\u0646\u06A9"
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const places = t5;
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      ASPHALT: "\u0622\u0633\u0641\u0627\u0644\u062A",
      DIRT: "\u062E\u0627\u06A9\u06CC",
      PAVEMENT: "\u067E\u06CC\u0627\u062F\u0647\u200C\u0631\u0627\u0647\u200C"
    };
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const roadTypes = t6;
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setShowMore(true);
    };
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const clickShowMore = t7;
  let t8;
  if ($[11] !== firstData || $[12] !== remainingData || $[13] !== roadAccessDescription || $[14] !== roadAccessType || $[15] !== showMore) {
    t8 = {
      places,
      distances,
      roadTypes,
      firstData,
      remainingData,
      roadAccessType,
      roadAccessDescription,
      clickShowMore,
      showMore
    };
    $[11] = firstData;
    $[12] = remainingData;
    $[13] = roadAccessDescription;
    $[14] = roadAccessType;
    $[15] = showMore;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};